import { useAuthContext } from 'app/auth'
import { KeyboardKeys } from 'app/enums'
import { useEffect } from 'react'
import { isMacOs } from 'react-device-detect'
import useKeyboardJs from 'react-use/lib/useKeyboardJs'

import { AuthApp } from './AuthApp'
import { UnauthApp } from './UnauthApp'

export const App = () => {
  const { user } = useAuthContext()

  const [isForwardPressed] = useKeyboardJs(
    isMacOs ? KeyboardKeys.NavigateForwardMac : KeyboardKeys.NavigateForward,
  )
  const [isBackwardPressed] = useKeyboardJs(
    isMacOs ? KeyboardKeys.NavigateBackwardMac : KeyboardKeys.NavigateBackward,
  )

  useEffect(() => {
    if (isForwardPressed) {
      history.forward()
    }
    if (isBackwardPressed) {
      history.back()
    }
  }, [isBackwardPressed, isForwardPressed])

  if (user.state === 'initial') {
    return null
  }

  if (user.state === 'unauthenticated') {
    return <UnauthApp />
  }

  return <AuthApp />
}
